import useGeoLocationTracker from '@infrastructure/context/geolocation/useGeoLocationTracker';

const GeoLocationTracker = () => {
  useGeoLocationTracker();
  return null;
};

export default GeoLocationTracker;
